import { Routes } from '@angular/router';
import { RegistrationComponent as AuthRegistrationComponent } from './pages/auth/register/registration';
import { StudentComponent } from './pages/student/student';
import { AdminComponent } from './pages/admin/admin';
import { authenticationGuard } from './core/guards/authentication.guard';
import { anyPermissionGuard, permissionGuard } from './core/guards/permission.guard';
import { Permissions } from './core/authorization/permissions';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home').then(m => m.HomeComponent)
  },
  {
    path: 'auth/login',
    loadComponent: () => import('./pages/auth/login-page/login-page').then(m => m.LoginPageComponent)
  },
  {
    path: 'auth/register',
    component: AuthRegistrationComponent
  },
  {
    path: 'auth/callback',
    loadComponent: () => import('./pages/auth/oauth-callback/oauth-callback').then(m => m.OAuthCallbackComponent)
  },
  {
    path: 'auth/verify-otp',
    loadComponent: () => import('./pages/auth/verify-otp/verify-otp').then(m => m.VerifyOtpComponent)
  },
  {
    path: 'auth/confirm-email',
    loadComponent: () => import('./pages/auth/confirm-email/confirm-email').then(m => m.ConfirmEmailComponent)
  },
  {
    path: 'student',
    component: StudentComponent,
    canActivate: [authenticationGuard, permissionGuard(Permissions.ApplicationSubmit)]
  },
  {
    path: 'flight-requests',
    loadComponent: () => import('./pages/flight-requests/flight-requests').then(m => m.FlightRequestsPage),
    canActivate: [authenticationGuard, permissionGuard(Permissions.FlightRequestSubmit)]
  },
  {
    // Public — no auth required. Lists public events and takes email-only signups.
    path: 'events',
    loadComponent: () => import('./pages/events/events').then(m => m.PublicEventsPage)
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [authenticationGuard, anyPermissionGuard(
      Permissions.ApplicationReview,
      Permissions.ScholarshipCreate,
      Permissions.ScholarshipTemplateView,
      Permissions.UserManage,
      Permissions.FeatureToggleView,
      Permissions.FlightRequestView,
      Permissions.AwardView,
      Permissions.ClaimView,
      Permissions.ExpenseView,
      Permissions.ReportsView,
    )]
  },
  {
    path: 'finance',
    loadComponent: () => import('./pages/admin/finance/finance').then(m => m.FinanceComponent),
    canActivate: [authenticationGuard, permissionGuard(Permissions.FinanceManage)]
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile').then(m => m.ProfileComponent),
    canActivate: [authenticationGuard]
  },
  {
    path: 'scholarships',
    loadComponent: () => import('./pages/home/scholarships/scholarships').then(m => m.ScholarshipsPage)
  },
  {
    // Public — no auth required. Lists alumni who opted in to share their details.
    path: 'alumni',
    loadComponent: () => import('./pages/alumni/alumni').then(m => m.AlumniPage)
  },
  {
    path: 'scholarships/:id/apply',
    loadComponent: () => import('./pages/scholarships/apply/apply').then(m => m.ApplyPage)
  },
  {
    path: 'scholarships/:id',
    loadComponent: () => import('./pages/home/scholarships/details/detail').then(m => m.DetailPage)
  },
  {
    // Public — no auth required. Referee accesses this via secure token link from email.
    path: 'referee/:token',
    loadComponent: () => import('./pages/referee/referee-form/referee-form').then(m => m.RefereeFormComponent)
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];
